<template>
  <table class="races-table table text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col">Race</th>
        <th scope="col">Creation</th>
        <th scope="col">Player amount</th>
        <th scope="col">Status</th>
      </tr>
    </thead>
    <tr
      v-for="race in races"
      :key="race.id"
    >
      <td>
        <rush-race-link :rushRaceId="createRushRaceId(race.id)"/>
      </td>
      <td>
        {{ race.ctime | getMomentStr }}
      </td>
      <td class="num">
        {{ race.participantAmount | getFormattedNumber }}
      </td>
      <td :class="getRushStatusClass(race.status)">
        {{ race.status | getRushRaceStatusName }}
      </td>
    </tr>
  </table>
</template>

<script>
import { getRushRaceStatusName } from '../model/rush_race.js';
import { getRushStatusClass    } from '../model/rush_race.js';

import RushRaceLink from './RushRaceLink.vue';

export default {
  name: 'RushRacePreviewsTable',

  components: {
    RushRaceLink
  },

  props: {
    rushId: {
      type: Number,
      required: true,
    },

    races: {
      type: Array,
      required: true,
    },

    offset: {
      type: Number,
      default: 0,
    }
  },

  methods: {
    /** @param {number} raceId */
    createRushRaceId(raceId) {
      return {
        rushId: this.rushId,
        raceId: raceId,
      };
    },

    getRushStatusClass,
  },

  filters: {
    getRushRaceStatusName,
  },
};
</script>

<style scoped>
.races-table {
  width: 1px;
}

.num {
  text-align: right;
}
</style>
